import type { IAbstractAtlasControlOptions } from 'app/src/features/Showcase/helpers/maputils'
import * as atlas from 'azure-maps-control'

export abstract class AbstractAtlasControl<TOptions extends IAbstractAtlasControlOptions> implements atlas.Control {
  protected _container: HTMLElement | undefined
  protected _button: HTMLButtonElement | undefined
  protected _darkColor = '#011c2c'
  protected _map: atlas.Map | undefined
  protected _options: TOptions | undefined = undefined

  constructor(options?: TOptions) {
    if (options) {
      this._options = { ...this._options, ...options }
    }
  }

  public abstract onAdd(map: atlas.Map, options?: atlas.ControlOptions): HTMLElement

  /**
   * Returns the set of translation text resources needed for the center and zoom control for a given language.
   * @param lang The language code to retrieve the text resources for.
   * @returns The translated text for the aria label for the center and zoom control.
   */
  protected abstract getAriaLabel(lang?: string): string

  protected getColorFromMapStyle(): string {
    const style = this._map?.getStyle().style
    let color = 'white'

    switch (style) {
      //When the style is dark (i.e. satellite, night), show the dark colored theme.
      case 'satellite':
      case 'satellite_road_labels':
      case 'grayscale_dark':
      case 'night':
        color = this._darkColor
        break
      //When the style is bright (i.e. road), show the light colored theme.
      case 'road':
      case 'grayscale_light':
      default:
        break
    }

    return color
  }
  protected mapStyleChanged(): void {
    if (this._button) {
      this._button.style.backgroundColor = this.getColorFromMapStyle()
    }
  }

  public onRemove(): void {
    if (this._container) {
      this._container.remove()
      this._container = undefined
    }

    if (this._options?.style === 'auto') {
      this._map?.events.remove('styledata', () => {
        this.mapStyleChanged()
      })
    }
    this._map = undefined
  }
}
